import moment from 'moment';
import * as MsgBarActions from '../system-shared/message-bar-action-creator';
import { getNewAccessTokenFromForcedRefresh } from '../auth/auth-middleware';
import * as api from './activity-log-api';

export const getActivityLogUrl = (startDate, endDate) => (dispatch, getState) =>
  dispatch(getNewAccessTokenFromForcedRefresh())
    .then(
      (token) =>
        Promise.resolve('/api/users/{userId}/audits/report?startDate={0}&endDate={1}&token={2}'
          .replace('{userId}', getState().profile.user.userId)
          .replace('{0}', moment(startDate).format('YYYY-MM-DD'))
          .replace('{1}', moment(endDate).format('YYYY-MM-DD'))
          .replace('{2}', token))
    );

export const downloadPersonalData = (patientId, callback) => (dispatch) =>
  api.getPersonalData(patientId).then(
    (downloadedFile) => {
      if (callback) {
        callback(downloadedFile.data);
      }
    },
    () => dispatch(MsgBarActions.showErrorMessage('personaldatadownloadfailed'))
  );
